import controller from './email-preferences.controller';
import template from './email-preferences.pug';

const EmailPreferencesComponent = {
  template,
  controller,
};

export default EmailPreferencesComponent;



// WEBPACK FOOTER //
// ./client/app/settings/preferences/email-preferences/email-preferences.component.js